import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import "./Footer.css";
import logoVertical from "../assets/logo-vertical.svg";
import {
  getScrollAnimationVariants,
  defaultScrollViewportSettings,
} from "../hooks/useScrollAnimation";
import { SOCIAL_URLS, CONTACT_EMAIL } from "../constants";

export default function Footer() {
  const { t, i18n } = useTranslation();
  const fadeInUp = getScrollAnimationVariants("fadeInUp");

  const changeLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
    // Update URL with language param without page reload
    const url = new URL(window.location.href);
    url.searchParams.set("lang", lang);
    window.history.replaceState({}, "", url.toString());
  };

  const currentLang = i18n.language;

  return (
    <motion.footer
      initial="hidden"
      whileInView="visible"
      viewport={defaultScrollViewportSettings}
      variants={fadeInUp}
    >
      <section className="footer-content">
        <div className="footer-main">
          <div className="footer-logo-section">
            <a href="/" className="footer-logo-link">
              <img src={logoVertical} alt="Logo" className="footer-logo" />
            </a>
          </div>

          <div className="footer-links-section">
            <div className="footer-column">
              <h4>{t("footer.navigation")}</h4>
              <a href="/">{t("footer.home")}</a>
              <a href="#about">{t("footer.aboutUs")}</a>
              <a href="#case-studies">{t("footer.caseStudies")}</a>
              <a href="#offer">{t("footer.ourOffer")}</a>
              <a href={`mailto:${CONTACT_EMAIL}`}>{t("footer.contact")}</a>
            </div>

            <div className="footer-column">
              <h4>{t("footer.followUs")}</h4>
              <a
                href={SOCIAL_URLS.tiktok}
                target="_blank"
                rel="noopener noreferrer"
              >
                TikTok
              </a>
              <a
                href={SOCIAL_URLS.instagram}
                target="_blank"
                rel="noopener noreferrer"
              >
                Instagram
              </a>
            </div>

            <div className="footer-column">
              <h4>{t("footer.language")}</h4>
              <button
                onClick={() => changeLanguage("pl")}
                className={`footer-lang-btn ${currentLang === "pl" ? "active" : ""}`}
              >
                {t("footer.polski")}
              </button>
              <button
                onClick={() => changeLanguage("en")}
                className={`footer-lang-btn ${currentLang === "en" ? "active" : ""}`}
              >
                {t("footer.english")}
              </button>
            </div>
          </div>
        </div>

        <div className="footer-divider"></div>

        <div className="footer-bottom">
          <p>{t("footer.copyright")}</p>
          <div className="footer-bottom-links">
            <a href="/privacy-policy">{t("footer.privacyPolicy")}</a>
          </div>
        </div>
      </section>
    </motion.footer>
  );
}
